export const API_BASE =
  (import.meta.env.VITE_API_URL as string | undefined) || "https://api.ckgo2.com";

/** The guide token lives in the URL path: `/g/<token>`. */
export function getToken(): string {
  const parts = window.location.pathname.split("/").filter(Boolean);
  if (parts[0] === "g" && parts[1]) return parts[1];
  return parts[parts.length - 1] || "";
}

const base = () => `${API_BASE}/api/portal/guide/${getToken()}`;

export async function fetchSnapshot<T>(): Promise<T> {
  const res = await fetch(base());
  const json = (await res.json()) as { success?: boolean; data?: T; message?: string };
  if (!res.ok || !json.success || !json.data) throw new Error(json.message || "Failed to load");
  return json.data;
}

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

/** POST a guide action; returns the fresh snapshot the server sends back. */
export async function postAction<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${base()}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const json = (await res.json().catch(() => ({}))) as {
    success?: boolean;
    data?: T;
    message?: string;
  };
  if (!res.ok || !json.success) throw new ApiError(json.message || "Request failed", res.status);
  return json.data as T;
}
